import axios from 'axios';
import { Swiper, SwiperSlide } from 'swiper/react';
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useEmblaCarousel from 'embla-carousel-react';

import { text } from '../../text';
import { URLS } from '../../config';
import { hooks } from '../../hooks';
import { utils } from '../../utils';
import { svg } from '../../assets/svg';
import { theme } from '../../constants';
import { components } from '../../components';
import { course as elements } from '../../course';
import { review as reviews } from '../../reviews';

import categoriesdata from '../../staticdata/categories';
import properties from '../../staticdata/properties';
import { reviewsData } from '../../staticdata/reviewData';
import banner from '../../assets/nestfin/BANNER IMAGE.jpg'
import { BlockHeading } from '../../components/BlockHeading';
import { CourseCard } from '../../course/CourseCard';
import carouselImage from '../../assets/nestfin/3d1.png'
import logo from "../../assets/nestfin/NexfinPng.png"
import { callService } from '../../customHook/callService';
import { fetchPropertyByFilters } from '../../environment';
import useApi from '../../customHook/useApi';



export interface Feature {
  feature_id: number;
  feature_name: string;
  icon: string;
}

export interface PropertyType {
  property_id: string;
  property_name: string;
  address: string;
  locality_id: string;
  locality_name: string | null;
  city_id: string;
  city_name: string;
  pincode: string;
  state: string;
  features: Feature[] | null;
  photos: any; // can refine this later
  minimum_rent: number;
}

export interface FilterResponse {
  success: boolean;
  statusCode: number;
  data: PropertyType[];
}


export const Home: React.FC = () => {
  const navigate = hooks.useNavigate();
  const location = useLocation();
  const { pathname } = useLocation();

  const [loading, setLoading] = useState(false);
  const [emblaRef, emblaApi] = useEmblaCarousel();
  const [activeIndex, setActiveIndex] = useState(0);
  const [coursesData, setCoursesData] = useState([]);
  const [bannersData, setBannersData] = useState([]);
  const [categoriesData, setCategoriesData] = useState<any>([]);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [startIndex, setStartIndex] = useState(0);

  const [viewport, setViewport] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });



  const selectedCity = sessionStorage.getItem("selectedCity")



  // CAll Api 
  const {
    data: propertyData,
    loading: propertyLoading,
    callApi: fetchProperty,
  } = useApi<FilterResponse>(fetchPropertyByFilters, {
    method: "POST",
    autoCall: false,
    dependencies: [],
  });



  useEffect(() => {

    // ✅ Call API immediately
    const payload = {
      leadId: "LEAD-B-2025-05-001",
      gender: "GENDER_MALE",
      minAmount: 1,
      maxAmount: 100000,
      localityId: "5,7",
    };

    fetchProperty(payload);
    console.log("Called API immediately with:", payload);
  }, []);


  useEffect(() => {
    console.log(propertyData?.data, "propertyData")
  }, [propertyData])



  useEffect(() => {
    const handleResize = () => {
      setViewport({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
    };
    scrollToTop();
  }, [pathname]);
  const handleSlideChange = () => {
    if (emblaApi) {
      setActiveIndex(emblaApi.selectedScrollSnap());
    }
  };
  useEffect(() => {
    if (emblaApi) {
      emblaApi.on('select', handleSlideChange);
    }
  }, [emblaApi]);
  useEffect(() => {
    getData();
  }, []);
  const getData = async () => {
    setLoading(false);

    // try {
    //   const results = await Promise.allSettled([
    //     axios.get(URLS.GET_COURSES),
    //     axios.get(URLS.GET_CATEGORIES),
    //     axios.get(URLS.GET_BANNERS),
    //   ]);

    //   const coursesResponse = results[0];
    //   const categoriesResponse = categoriesdata;
    //   const bannersResponse = results[2];

    //   if (coursesResponse.status === 'fulfilled') {
    //     setCoursesData(coursesResponse.value.data.courses);
    //   } else {
    //     console.error('Error fetching courses:', coursesResponse.reason);
    //   }

    //   if (categoriesResponse.status === 'fulfilled') {
    //     setCategoriesData(categoriesResponse?.categories);
    //   } else {
    //     // console.error('Error fetching categories:', categoriesResponse?.reason);
    //   }

    //   if (bannersResponse.status === 'fulfilled') {
    //     setBannersData(bannersResponse.value.data.banners);
    //   } else {
    //     console.error('Error fetching banners:', bannersResponse.reason);
    //   }
    // } catch (error) {
    //   console.error('Unexpected error:', error);
    // } finally {
    //   setLoading(false);
    // }
  };


  useEffect(() => {
    const leadHomePage = async () => {
      try {
        const response = await callService("HOMEPAGE");
        console.log("✅ HOMEPAGE success:", response);
      } catch (error) {
        console.error("❌ HOMEPAGE failed:", error);
      }
    };
    leadHomePage();
  }, []);


  // START COMPONENT 
  const renderBottomTabBar = (): JSX.Element => {
    return <components.BottomTabBar />;
  };

  const renderTopBlock = (): JSX.Element => {
    return (
      <div
        className='container'
        style={{ marginBottom: 0 }}
      >
        <div
          className=''
          style={{ marginTop: 20, marginBottom: 35 }}
        >
          <div style={{ flexDirection: "column" }}>
            <text.H3 numberOfLines={1}>Let's Find your Dream House home page </text.H3>

            {
              selectedCity && <p
                style={{ color: theme.colors.secondaryTextColor, marginBottom: -10 }}
              >
                {selectedCity}
              </p>
            }

          </div>


        </div>
      </div>
    );
  };

  const renderIndicator = (): JSX.Element => {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          bottom: 20,
          left: 20,
          flexDirection: 'row',
          gap: 8,
        }}
      >
        {bannersData?.map((item: any, index: number) => {
          const isSelected = index === activeIndex;
          return (
            <div
              style={{
                background: isSelected
                  ? "#7065F0"
                  : theme.colors.secondaryTextColor,
                width: 10,
                // width: isSelected ? 25 : 10,
                height: 10,
                borderRadius: 5,
              }}
              key={index}
            />
          );
        })}
      </div>
    );
  };
  const renderSearchBar = (): JSX.Element => {
    return (
      <div className='container'>
        <div
          style={{
            padding: '9px 16px',
            width: '100%',
            marginBottom: 20,
            left: 20,
            top: 24,
            borderRadius: 5,
            border: '1px solid #ddd', // <-- added border
            backgroundColor: '#fff',  // optional: improves contrast
            ...utils.rowCenter(),
          }}
        >
          <svg.SearchSvg />
          <text.T14 style={{ marginLeft: 8, marginRight: 'auto' }}>
            Search Location
          </text.T14>
          <div
            style={{ cursor: 'pointer' }}
            onClick={() => navigate('/onbording7')}
          >
            <svg.FilterSvg />
          </div>
        </div>

      </div>
    );
  };


  const renderCarouselContent = (): JSX.Element => {
    return (
      <div className='embla' ref={emblaRef}>

        <div className='embla__container'>

          {propertyData?.data.slice(1, 4).map((course: any, index: number) => {

            return (
              <div
                key={course.property_id}
                className='embla__slide carousel-slide'
                onClick={() => {
                  navigate('/course-details', {
                    state: { course: coursesData[index] },
                  });
                }}
              >
                <div
                  className='carousel-image-wrapper'
                  style={{ backgroundImage: `url(${carouselImage})` }}
                >

                  <div className="bannerCardContent">
                    <p className="bannerCardTag">Semi Furnished</p>
                    <p className="bannerCardPrice">Rs. {course.minimum_rent} / month</p>
                    <p className="bannerCardType">{course.property_name}</p>
                    <p className="bannerCardLocation">{course.city_name}, {course.pincode}</p>
                  </div>
                  <elements.CourseRating
                    course={course}
                    containerStyle={{
                      margin: 2,
                      position: 'absolute',
                      right: 18,
                      bottom: 10,
                    }}
                  />

                  {/* <elements.CourseInWishlist
                    course={course}
                    size={20}
                    style={{ position: 'absolute', right: 20, top: 23 }}
                  /> */}

                </div>

              </div>

            );
          })}

        </div>
      </div>
    );
  };


  const renderCarousel = () => {
    return (
      <div style={{ position: 'relative', marginBottom: 10, marginTop: 15 }}>
        <components.BlockHeading
          title='Perfect Match '
          viewAllOnClick={() => {
            navigate('/category-list', {
              state: {
                title: 'Perfect Match',
                propertyList: propertyData?.data,
              },
            });

          }}
          containerStyle={{ marginBottom: 12, padding: '0 20px' }}
        />
        {renderCarouselContent()}
        {renderIndicator()}
      </div>
    );
  };


  // Perfect Match for You
  const renderTopRatedCourses = (): JSX.Element => {
    const defaultImage =
      "https://drahomes.in/images/properties-chennai-dra-astra-flats-madhavaram-chennai.jpg";
    return (
      <div style={{ marginBottom: 0, marginTop: 40 }}>
        <div style={{ backgroundColor: "#f0fff0", padding: "20px 0" }}>
          <components.BlockHeading
            title='Smart Suggestions'
            viewAllOnClick={() => {
              navigate('/category-list', {
                state: {
                  title: 'Smart Suggestions',
                  propertyList: propertyData?.data,
                },
              });

            }}
            containerStyle={{ marginBottom: 12, padding: '0 20px' }}
          />

          {propertyData?.data.slice(2, 4).map((course: any, index, array) => {
            const isLast = index === array.length - 1;

            return (
              <div key={course.property_id} style={{
                width: '100%',
                padding: '0 20px',
                cursor: 'pointer',
                userSelect: 'none',
                display: 'flex',
                alignItems: 'center',
                marginBottom: isLast ? 0 : 10,
                paddingBottom: isLast ? 0 : 10,
                borderBottomWidth: isLast ? 0 : 1,
                borderBottomStyle: isLast ? 'none' : 'solid',
                borderBottomColor: `rgba(59, 89, 153, 0.1)`,
              }} onClick={() => navigate('/course-details', { state: { course } })}>
                <div style={{
                  minWidth: 140,
                  minHeight: 110,
                  marginRight: 12,
                  position: 'relative',
                }}>
                  <img
                    src={course?.photos || defaultImage}
                    style={{
                      width: '100%',
                      height: '100%',
                      borderRadius: 10,
                      position: 'absolute',
                      inset: 0,
                    }}
                  />

                  {/* <elements.CourseRating
                    course={course}
                    containerStyle={{
                      margin: 2,
                      position: 'absolute',
                      bottom: 0,
                      left: 0,
                    }}
                  /> */}
                </div>
                <div style={{ width: '100%', position: 'relative' }}>
                  <div style={{ display: 'flex', marginLeft: 10 }}>
                    <div>
                      <p className='typeOfRoom' style={{ fontSize: "13px" }}>Semi Furnished</p>
                      <p className='typeOfRoom' style={{ fontSize: "17px", marginTop: "6px" }}>{course?.property_name}</p>
                      <text.T16 style={{ color: "#7065F0", ...theme.fonts.Lato_700Bold }}>
                        ₹{course?.minimum_rent} / Month
                      </text.T16>
                      <elements.CourseName
                        course={course}
                        numberOfLines={1}
                        shortName={true}
                      />
                      <text.T16 style={{ color: "#000" }}>
                        {course?.city_name} {course?.pincode}
                      </text.T16>
                    </div>
                  </div>
                  {/* <elements.CourseInWishlist
                    course={course}
                    size={20}
                    style={{ position: 'absolute', right: 0, top: 0 }}
                  /> */}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };


  const renderNearest1 = (): JSX.Element => {
    return (
      <div style={{ marginBottom: 0, marginTop: 30 }}>
        <BlockHeading
          title='Nearest For You'
          viewAllOnClick={() => {
            navigate('/category-list', { state: { title: 'Nearest For You' } });
          }}
          containerStyle={{ marginBottom: 12, padding: '0 20px' }}
        />

        <Swiper
          spaceBetween={16}
          slidesPerView={'auto'}
          pagination={{ clickable: true }}
        >
          {properties?.properties.map((course: any, index, array) => {
            const isLast = index === array.length - 1;
            return (
              <SwiperSlide
                key={course.id}
                style={{
                  width: 230,
                  cursor: 'pointer',
                  userSelect: 'none',
                  borderRadius: 10,
                  display: 'flex',
                  flexDirection: 'column',
                  position: 'relative',
                }}
                onClick={() => {
                  navigate('/course-details', { state: { course } });
                }}
              >
                <div
                  style={{
                    position: 'relative',
                    width: '100%',
                    height: 170,
                    marginBottom: 10,
                  }}
                >
                  <img
                    src={course?.preview_90x90}
                    alt={course?.name}
                    style={{
                      width: '100%',
                      height: '100%',
                      position: 'absolute',
                      borderRadius: 10,
                      inset: 0,
                    }}
                  />

                  {/* <elements.CourseInWishlist
                    course={course}
                    size={20}
                    style={{
                      position: 'absolute',
                      right: 0,
                      top: 0,
                      margin: 10,
                    }}
                    customFillColor={theme.colors.white}
                    customStrokeColor={theme.colors.white}
                  /> */}
                </div>
                <div style={{ display: 'flex' }}>

                  <div>
                    {course.oldPrice && (
                      <span
                        style={{
                          marginRight: 6,
                          color: theme.colors.secondaryTextColor,
                          textDecorationLine: 'line-through',
                          ...theme.fonts.Lato_700Bold,
                          fontSize: 18,
                          lineHeight: 1.5,
                          marginTop: 3,
                        }}
                      >
                        ${course.oldPrice.toFixed(2)}
                      </span>
                    )}
                    <text.T16 style={{ color: "#7065F0", ...theme.fonts.Lato_700Bold, }}>
                      ${course.price.toFixed(2)}/Month
                    </text.T16>
                    <elements.CourseName
                      course={course}
                      numberOfLines={1}
                      shortName={true}
                    />
                    <text.T16 style={{ color: "#000" }}>
                      London University
                    </text.T16>
                    <elements.areaDescription
                      course={course}
                    // numberOfLines={1}
                    // shortName={true}
                    />

                  </div>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    );
  };
  const renderReview = (): JSX.Element => {
    return (
      <div style={{ marginBottom: 0, marginTop: 40 }}>
        <components.BlockHeading
          title='What people are saying'

          // viewAllOnClick={() => {
          //   // navigate('/category-list', { state: { title: 'Nearest For You' } });
          // }}
          containerStyle={{ marginBottom: 12, padding: '0 20px' }}

        />
        <Swiper
          spaceBetween={16}
          slidesPerView="auto"
          // centeredSlides={true}
          pagination={{ clickable: true }}
        >

          {reviewsData?.slice(0, 3).map((review: any, index, array) => {
            const isLast = index === array.length - 1;
            return (
              <SwiperSlide
                key={review.id}
                style={{
                  width: 350,
                  cursor: 'pointer',
                  userSelect: 'none',
                  borderRadius: 10,
                  display: 'flex',
                  flexDirection: 'column',
                  position: 'relative',
                  backgroundColor: "#F9FAFC",
                  padding: "20px 20px 0px 20px"

                }}
                onClick={() => {

                  // navigate('/course-details', { state: { review } });
                }}
              >
                <div
                  style={{
                    position: 'relative',
                    width: '100%',
                    height: 320,
                    marginBottom: 10,
                  }}
                >
                  <img
                    src={review.image}
                    alt={review.name}
                    style={{
                      width: '100%',
                      height: '100%',
                      position: 'absolute',
                      borderRadius: 3,
                      inset: 0,
                    }}
                  />
                </div>
                <div style={{}}>
                  <reviews.ReviewCard
                    review={review}
                    section='reviews'
                  />
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    );
  };


  const renderCounter = (): JSX.Element => {
    return (
      <div style={{ marginBottom: 20, marginTop: 20 }}>

        <div style={{
          ...utils.rowCenter(),
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          textAlign: "center",
          gap: "10px"
        }}>

          <h3 style={{
            color: theme.colors.darkTextColor,
            ...theme.fonts.Lato_700Bold,
            ...theme.flex,
            fontSize: 32,
          }} >Trusted by</h3>


          <h3 style={{
            color: theme.colors.darkTextColor,
            ...theme.fonts.Lato_700Bold,
            ...theme.flex,
            fontSize: 28,
          }} >Customers in Delhi NCR</h3>
          <h3 style={{
            // lineHeight: 1,
            color: theme.colors.darkTextColor,
            ...theme.fonts.Lato_700Bold,
            ...theme.flex,
            fontSize: 28
          }} > and growing every day</h3>

        </div>

      </div>
    );
  };


  const renderBottomCard = (): JSX.Element => {

    const handleShare = () => {
      if (navigator.share) {
        navigator
          .share({
            title: 'Check out Nestfin!',
            text: 'I found this awesome app — try it out!',
            url: 'https://nestfin.app/',
          })
          .then(() => console.log('Thanks for sharing!'))
          .catch((error) => console.error('Error sharing:', error));
      } else {
        // Fallback if Web Share API is not supported
        alert('Sharing not supported on this browser. Copy this link: https://nestfin.app/');
      }
    };

    return (
      <div className="bottom-card-container">
        <div className="bottom-card-content">
          {/* Left Content */}
          <div className="bottom-card-left">
            <h3 className="bottom-card-heading">Like the app?</h3>
            <h3 className="bottom-card-subheading">Share the app with your friends!</h3>
            <button className="bottom-card-button" onClick={handleShare}>Share Now</button>
          </div>

          {/* Right Image */}
          <div className="bottom-card-image-wrapper">
            <img
              src={require("../../assets/nestfin/bottomcardimg.png")}
              alt="Share the app illustration"
            />
          </div>
        </div>
      </div>
    );
  };



  const renderPopular = (): JSX.Element => {
    return (
      <div
        style={{ marginBottom: 0, marginTop: 30 }} >
        <components.BlockHeading
          title='Recently Added Properties '
          viewAllOnClick={() => {
            navigate('/category-list', { state: { title: 'Recently Added Properties' } });
          }}
          containerStyle={{ marginBottom: 12, padding: '0 20px' }}
        />
        <Swiper
          spaceBetween={16}
          slidesPerView={'auto'}
          pagination={{ clickable: true }}
        >
          {properties?.properties.map((course: any, index, array) => {
            const isLast = index === array.length - 1;
            return (
              <SwiperSlide
                key={course.id}
                style={{
                  width: 230,
                  cursor: 'pointer',
                  userSelect: 'none',
                  borderRadius: 10,
                  display: 'flex',
                  flexDirection: 'column',
                  position: 'relative',
                }}
                onClick={() => {
                  navigate('/course-details', { state: { course } });
                }}
              >
                <div
                  style={{
                    position: 'relative',
                    width: '100%',
                    height: 170,
                    marginBottom: 10,
                  }}
                >
                  <img
                    src={course.preview_90x90}
                    alt={course.name}
                    style={{
                      width: '100%',
                      height: '100%',
                      position: 'absolute',
                      borderRadius: 10,
                      inset: 0,
                    }}
                  />
                  <elements.CourseRating
                    course={course}
                    containerStyle={{
                      position: 'absolute',
                      left: 2,
                      bottom: 2,
                    }}
                  />
                  {/* <elements.CourseInWishlist
                    course={course}
                    size={20}
                    style={{
                      position: 'absolute',
                      right: 0,
                      top: 0,
                      margin: 10,
                    }}
                    customFillColor={theme.colors.white}
                    customStrokeColor={theme.colors.white}
                  /> */}
                </div>
                <div style={{ display: 'flex' }}>
                  {/* <div style={{ marginRight: 8 }}>
                    <svg.PlaySvg />
                  </div> */}
                  <div>
                    <elements.CourseName
                      course={course}
                      numberOfLines={1}
                      shortName={true}
                    />

                    <text.T16 style={{ color: theme.colors.secondaryTextColor }}>
                      London University
                    </text.T16>
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    );
  };
  const renderHeader = (): JSX.Element => {
    return (
      <components.Header
        goBack={false}
        line={false}
        leftlogo={true}
        rightlogo={true}
        // search={true}
        filter={false}
        // logo={true}
        title={' '}
        centerImageSrc={logo}
      />
    );
  };


  const renderBanner = (): JSX.Element => {
    return (
      <div className='container' >
        <img src={banner} alt="" style={{ borderRadius: "11px", overflow: "hidden" }} />
      </div>
    )
  }

  const renderBanner2 = (): JSX.Element => {
    return (
      <div className='container' style={{ marginTop: "25px" }} >
        <img src={banner} alt="" style={{ borderRadius: "11px", overflow: "hidden" }} />
      </div>
    )
  }

  const renderNearest = (): JSX.Element => {
    const defaultImage =
      "https://assets-news.housing.com/news/wp-content/uploads/2022/03/28143140/Difference-between-flat-and-apartment.jpg";
    return (
      <div style={{ marginBottom: 0, marginTop: 35 }}>
        <BlockHeading
          title='Recent Search'
          viewAllOnClick={() => {
            navigate('/category-list', {
              state: {
                title: 'Recent Search',
                propertyList: propertyData?.data,
              },
            });

          }}
          containerStyle={{ marginBottom: 12, padding: '0 20px' }}
        />
        <Swiper
          spaceBetween={16}
          slidesPerView={'auto'}
          pagination={{ clickable: true }}
        >

          {propertyData?.data.slice(0, 3).map((course: any, index, array) => {
            const isLast = index === array.length - 1;
            return (
              <SwiperSlide
                key={course.property_id}
                style={{
                  width: 230,
                  cursor: 'pointer',
                  userSelect: 'none',
                  borderRadius: 10,
                  display: 'flex',
                  flexDirection: 'column',
                  position: 'relative',
                }}
                onClick={() => {
                  navigate('/course-details', { state: { course } });
                }}
              >

                <div className="nearestCardWrapper">
                  <div
                    className="nearestCardBackground"
                    style={{
                      backgroundImage: `url(${course.photos || defaultImage})`,
                    }}
                  />

                  <div className="nearestCardContent">
                    {/* <p className="nearestCardTag">Semi Furnished</p> */}
                    <p className="nearestCardType">{course.property_name}</p>
                    <p className="nearestCardPrice">Rs. {course.minimum_rent} / month</p>
                    <p className="nearestCardLocation">{course.city_name} {course.pincode}</p>
                  </div>

                  {/* <elements.CourseInWishlist
                    course={course}
                    size={20}
                    style={{
                      position: 'absolute',
                      right: 0,
                      top: 0,
                      margin: 10,
                      zIndex: 2,
                    }}
                    customFillColor={theme.colors.white}
                    customStrokeColor={theme.colors.white}
                  /> */}
                </div>

              </SwiperSlide>
            );
          })}

        </Swiper>
      </div>
    );
  };




  const renderNearest2 = (): JSX.Element => {
    const defaultImage =
      "https://assets-news.housing.com/news/wp-content/uploads/2022/03/28143140/Difference-between-flat-and-apartment.jpg";
    return (
      <div style={{ marginBottom: 0, marginTop: 35 }}>
        <BlockHeading
          title='Budget-Friendly'
          viewAllOnClick={() => {
            navigate('/category-list', {
              state: {
                title: 'Budget-Friendly',
                propertyList: propertyData?.data,
              },
            });

          }}
          containerStyle={{ marginBottom: 12, padding: '0 20px' }}
        />

        <Swiper
          spaceBetween={16}
          slidesPerView={'auto'}
          pagination={{ clickable: true }}
        >
          {propertyData?.data.slice(0, 3).map((course: any, index, array) => {
            const isLast = index === array.length - 1;
            return (
              <SwiperSlide
                key={course.property_id}
                style={{
                  width: 230,
                  cursor: 'pointer',
                  userSelect: 'none',
                  borderRadius: 10,
                  display: 'flex',
                  flexDirection: 'column',
                  position: 'relative',
                }}
                onClick={() => {
                  navigate('/course-details', { state: { course } });
                }}
              >

                <div className="nearestCardWrapper">
                  <div
                    className="nearestCardBackground"
                    style={{
                      backgroundImage: `url(${course.photos || defaultImage})`,
                    }}
                  />

                  <div className="nearestCardContent">
                    {/* <p className="nearestCardTag">Semi Furnished</p> */}
                    <p className="nearestCardType">{course.property_name}</p>
                    <p className="nearestCardPrice">Rs. {course.minimum_rent} / month</p>
                    <p className="nearestCardLocation">{course.city_name} {course.pincode}</p>
                  </div>

                  {/* <elements.CourseInWishlist
                    course={course}
                    size={20}
                    style={{
                      position: 'absolute',
                      right: 0,
                      top: 0,
                      margin: 10,
                      zIndex: 2,
                    }}
                    customFillColor={theme.colors.white}
                    customStrokeColor={theme.colors.white}
                  /> */}
                </div>

              </SwiperSlide>
            );
          })}

        </Swiper>
      </div>
    );
  };




  const renderReelReview = (): JSX.Element => {

    const videoList = [
      {
        id: 1,
        src: 'https://videos.pexels.com/video-files/4778723/4778723-uhd_1440_2732_25fps.mp4',
        title: '“The stay was comfortable and the amenities were top-notch. Great experience overall!”',
        name: 'Aarav Mehta',
        location: 'Delhi, Azadpur',
      },
      {
        id: 2,
        src: 'https://videos.pexels.com/video-files/27333239/12119964_1440_2560_30fps.mp4',
        title: '“Very clean and secure. Felt just like home. Highly recommend this PG!”',
        name: 'Sneha Kapoor',
        location: 'Delhi, Nirman Vihar',
      },
      {
        id: 3,
        src: 'https://videos.pexels.com/video-files/3832197/3832197-uhd_1440_2732_25fps.mp4',
        title: '“Responsive management and peaceful environment. Perfect for working professionals.”',
        name: 'Rohit Sharma',
        location: 'Noida, Sector 62',
      },
      {
        id: 4,
        src: 'https://videos.pexels.com/video-files/7821798/7821798-hd_1080_1920_30fps.mp4',
        title: '“Affordable rent, well-maintained rooms, and friendly roommates.”',
        name: 'Priya Nair',
        location: 'Noida, Sector 63',
      },
    ];

    return (
      <div style={{ marginTop: 40 }}>
        <components.BlockHeading
          title="What people are saying"
          // viewAllOnClick={() => { }}
          containerStyle={{ marginBottom: 12, padding: '0 20px' }}
        />

        <Swiper spaceBetween={16} slidesPerView="auto">
          {videoList.map((video, index) => (
            <SwiperSlide
              key={video.id}
              style={{
                width: 200,
                height: 355,
                borderRadius: 10,
                overflow: 'hidden',
                backgroundColor: '#000',
                position: 'relative',
                cursor: 'pointer',
              }}
              onClick={() => {
                setStartIndex(index);
                setIsFullscreen(true);
              }}
            >
              <video
                src={video.src}
                autoPlay
                muted
                loop
                playsInline
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  borderRadius: 10,
                }}
              />
              <div
                style={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  right: 0,
                  background: 'rgba(0, 0, 0, 0.6)',
                  color: '#fff',
                  padding: '10px',
                  fontSize: 12,
                  lineHeight: 1.4,
                }}
              >
                <div style={{ marginBottom: 6 }}>{video.title}</div>
                <div style={{ fontWeight: 'bold' }}>{video.name}</div>
                <div>{video.location}</div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Fullscreen Swiper Modal */}
        {isFullscreen && (
          <div
            style={{
              position: 'fixed',
              inset: 0,
              background: '#000',
              zIndex: 9999,
            }}
          >
            <button
              onClick={() => setIsFullscreen(false)}
              style={{
                position: 'absolute',
                top: 20,
                right: 20,
                zIndex: 10000,
                color: '#fff',
                fontSize: 24,
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
              }}
            >
              ✕
            </button>
            <Swiper
              initialSlide={startIndex}
              spaceBetween={0}
              slidesPerView={1}
              id='handleVideo'
            // style={{ height: '100%', width: '100%', padding: "0" }}
            >
              {videoList.map((video) => (
                <SwiperSlide key={video.id}>
                  <video
                    src={video.src}
                    autoPlay
                    muted
                    loop
                    controls
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                    }}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        )}
      </div>
    );
  };


  const renderContent = (): JSX.Element => {
    return (
      <main>
        {renderTopBlock()}
        {renderSearchBar()}
        {renderBanner()}
        {/* {renderReviewReels()} */}
        {renderNearest()}
        {renderTopRatedCourses()}
        {renderCarousel()}
        {renderNearest2()}
        {renderBanner2()}
        {/* {renderPopular()} */}
        {renderReelReview()}
        {renderReview()}
        {renderCounter()}
        {renderBottomCard()}
        {/* 
         */}
      </main>
    );
  };

  return (
    <>
      {renderHeader()}
      {renderContent()}
      {renderBottomTabBar()}
    </>
  );
};






// import axios from 'axios';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import React, { useState, useEffect } from 'react';
// import { useLocation } from 'react-router-dom';
// import useEmblaCarousel from 'embla-carousel-react';

// import { text } from '../../text';
// import { URLS } from '../../config';
// import { hooks } from '../../hooks';
// import { utils } from '../../utils';
// import { svg } from '../../assets/svg';
// import { theme } from '../../constants';
// import { components } from '../../components';
// import { course as elements } from '../../course';
// import { review as reviews } from '../../reviews';

// import categoriesdata from '../../staticdata/categories';
// import properties from '../../staticdata/properties';
// import { reviewsData } from '../../staticdata/reviewData';

// export const Home: React.FC = () => {
//   const navigate = hooks.useNavigate();
//   const location = useLocation();
//   const { pathname } = useLocation();

//   const [loading, setLoading] = useState(false);
//   const [emblaRef, emblaApi] = useEmblaCarousel();
//   const [activeIndex, setActiveIndex] = useState(0);
//   const [coursesData, setCoursesData] = useState([]);
//   const [bannersData, setBannersData] = useState([]);
//   const [categoriesData, setCategoriesData] = useState<any>([]);
//   const [viewport, setViewport] = useState({
//     width: window.innerWidth,
//     height: window.innerHeight,
//   });
//   useEffect(() => {
//     const handleResize = () => {
//       setViewport({
//         width: window.innerWidth,
//         height: window.innerHeight,
//       });
//     };
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);
//   useEffect(() => {
//     const scrollToTop = () => {
//       window.scrollTo(0, 0);
//       document.documentElement.scrollTop = 0;
//     };
//     scrollToTop();
//   }, [pathname]);
//   const handleSlideChange = () => {
//     if (emblaApi) {
//       setActiveIndex(emblaApi.selectedScrollSnap());
//     }
//   };
//   useEffect(() => {
//     if (emblaApi) {
//       emblaApi.on('select', handleSlideChange);
//     }
//   }, [emblaApi]);
//   useEffect(() => {
//     getData();
//   }, []);
//   const getData = async () => {
//     setLoading(true);

//     try {
//       const results = await Promise.allSettled([
//         axios.get(URLS.GET_COURSES),
//         axios.get(URLS.GET_CATEGORIES),
//         axios.get(URLS.GET_BANNERS),
//       ]);

//       const coursesResponse = results[0];
//       const categoriesResponse = categoriesdata;
//       const bannersResponse = results[2];

//       if (coursesResponse.status === 'fulfilled') {
//         setCoursesData(coursesResponse.value.data.courses);
//       } else {
//         console.error('Error fetching courses:', coursesResponse.reason);
//       }

//       if (categoriesResponse.status === 'fulfilled') {
//         setCategoriesData(categoriesResponse?.categories);
//       } else {
//         // console.error('Error fetching categories:', categoriesResponse?.reason);
//       }

//       if (bannersResponse.status === 'fulfilled') {
//         setBannersData(bannersResponse.value.data.banners);
//       } else {
//         console.error('Error fetching banners:', bannersResponse.reason);
//       }
//     } catch (error) {
//       console.error('Unexpected error:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const renderBottomTabBar = (): JSX.Element => {
//     return <components.BottomTabBar />;
//   };

//   const renderTopBlock = (): JSX.Element => {
//     return (
//       <div
//         className='container'
//         style={{ marginBottom: 0 }}
//       >
//         <div
//           className=''
//           style={{ marginTop: 20, marginBottom: 35 }}
//         >
//           <div style={{ flexDirection: "column" }}>
//             <text.H3 numberOfLines={1}>Let's Find your Dream House home page </text.H3>
//             <p
//               style={{ color: theme.colors.secondaryTextColor, marginBottom: -10 }}
//             >
//               Gurugram
//             </p>
//           </div>


//         </div>
//       </div>
//     );
//   };
//   const renderIndicator = (): JSX.Element => {
//     return (
//       <div
//         style={{
//           display: 'flex',
//           justifyContent: 'center',
//           bottom: 20,
//           left: 20,
//           flexDirection: 'row',
//           gap: 8,
//         }}
//       >
//         {bannersData?.map((item: any, index: number) => {
//           const isSelected = index === activeIndex;
//           return (
//             <div
//               style={{
//                 background: isSelected
//                   ? "#7065F0"
//                   : theme.colors.secondaryTextColor,
//                 width: 10,
//                 // width: isSelected ? 25 : 10,
//                 height: 10,
//                 borderRadius: 5,
//               }}
//               key={index}
//             />
//           );
//         })}
//       </div>
//     );
//   };
//   const renderSearchBar = (): JSX.Element => {
//     return (
//       <div className='container'>
//         <div
//           style={{
//             padding: '9px 16px',
//             width: '100%',
//             marginBottom: 20,
//             left: 20,
//             top: 24,
//             borderRadius: 5,
//             border: '1px solid #ddd', // <-- added border
//             backgroundColor: '#fff',  // optional: improves contrast
//             ...utils.rowCenter(),
//           }}
//         >
//           <svg.SearchSvg />
//           <text.T14 style={{ marginLeft: 8, marginRight: 'auto' }}>
//             Search Location
//           </text.T14>
//           <div
//             style={{ cursor: 'pointer' }}
//             onClick={() => navigate('/filter')}
//           >
//             <svg.FilterSvg />
//           </div>
//         </div>

//       </div>
//     );
//   };

//   const renderCarouselContent = (): JSX.Element => {
//     return (
//       <div
//         className='embla'
//         ref={emblaRef}
//         style={{ marginBottom: 20, marginTop: 40 }}
//       >
//         <div className='embla__container'>
//           {bannersData.map((item: any, index: number, array: any[]) => {
//             return (
//               <div
//                 key={item.id}
//                 className='embla__slide'
//                 style={{
//                   position: 'relative',
//                   width: '100%',
//                   overflow: 'hidden',
//                   cursor: 'pointer',
//                   userSelect: 'none',
//                   padding: '0 20px',
//                 }}
//               >
//                 <img
//                   src={item.banner}
//                   style={{ height: '100%', objectFit: 'cover', borderRadius: 10 }}
//                   onClick={() => {
//                     navigate('/course-details', {
//                       state: { course: coursesData[0] },
//                     });
//                   }}
//                 />
//               </div>
//             );
//           })}
//         </div>
//       </div>
//     );
//   };

//   const renderCarousel = () => {
//     return (
//       <div style={{ position: 'relative', marginBottom: 10 }}>
//         {renderCarouselContent()}
//         {renderIndicator()}
//       </div>
//     );
//   };

//   // const renderCategories = (): JSX.Element => {
//   //   return (
//   //     <div style={{ marginBottom: 0, marginTop: 40 }}>
//   //       <components.BlockHeading
//   //         title='Categories'
//   //         viewAllOnClick={() => {
//   //           navigate('/category-grid');
//   //         }}
//   //         containerStyle={{ marginBottom: 12, padding: '0 20px' }}
//   //       />
//   //       <Swiper
//   //         spaceBetween={10}
//   //         slidesPerView={'auto'}
//   //         pagination={{ clickable: true }}
//   //       >
//   //         {categoriesData.map((category: any, index: number, array: any) => {
//   //           return (
//   //             <SwiperSlide
//   //               key={category.id}
//   //               style={{
//   //                 width: 'auto',
//   //                 position: 'relative',
//   //                 cursor: 'pointer',
//   //                 userSelect: 'none',
//   //                 padding: '8px 20px',
//   //                 height: 89,
//   //               }}
//   //               onClick={() => {
//   //                 navigate('/category-list', { state: { title: category.name } });
//   //               }}
//   //             >
//   //               <img
//   //                 src={category.image}
//   //                 alt={category.name}
//   //                 style={{
//   //                   position: 'absolute',
//   //                   width: '100%',
//   //                   height: '100%',
//   //                   top: 0,
//   //                   left: 0,
//   //                   zIndex: -1,
//   //                   borderRadius: 10,
//   //                   objectFit: 'cover',
//   //                 }}
//   //               />
//   //               <text.T14
//   //                 numberOfLines={1}
//   //                 style={{
//   //                   textTransform: 'capitalize',
//   //                   ...theme.fonts.Lato_700Bold,
//   //                   color: theme.colors.white,
//   //                 }}
//   //               >
//   //                 {category.name}
//   //               </text.T14>
//   //             </SwiperSlide>
//   //           );
//   //         })}
//   //       </Swiper>
//   //     </div>
//   //   );
//   // };

//   const renderTopRatedCourses = (): JSX.Element => {
//     return (
//       <div style={{ marginBottom: 0, marginTop: 40 }}>
//         <components.BlockHeading
//           title='Recommanded For you'
//           viewAllOnClick={() => {
//             navigate('/category-list', { state: { title: 'Recommanded For you' } });
//           }}
//           containerStyle={{ marginBottom: 12, padding: '0 20px' }}
//         />
//         {properties?.properties.slice(0, 3).map((course: any, index, array) => {
//           const isLast = index === array.length - 1;

//           return (
//             <elements.CourseCard
//               key={course.id}
//               course={course}
//               isLast={isLast}
//               section='top rated'
//             />
//           );
//         })}

//       </div>
//     );
//   };

//   const renderNearest = (): JSX.Element => {
//     return (
//       <div style={{ marginBottom: 0, marginTop: 40 }}>
//         <components.BlockHeading
//           title='Nearest For You'
//           viewAllOnClick={() => {
//             navigate('/category-list', { state: { title: 'Nearest For You' } });
//           }}
//           containerStyle={{ marginBottom: 12, padding: '0 20px' }}
//         />
//         <Swiper
//           spaceBetween={16}
//           slidesPerView={'auto'}
//           pagination={{ clickable: true }}
//         >
//           {properties?.properties.map((course: any, index, array) => {
//             const isLast = index === array.length - 1;
//             return (
//               <SwiperSlide
//                 key={course.id}
//                 style={{
//                   width: 230,
//                   cursor: 'pointer',
//                   userSelect: 'none',
//                   borderRadius: 10,
//                   display: 'flex',
//                   flexDirection: 'column',
//                   position: 'relative',
//                 }}
//                 onClick={() => {
//                   navigate('/course-details', { state: { course } });
//                 }}
//               >
//                 <div
//                   style={{
//                     position: 'relative',
//                     width: '100%',
//                     height: 170,
//                     marginBottom: 10,
//                   }}
//                 >
//                   <img
//                     src={course.preview_90x90}
//                     alt={course.name}
//                     style={{
//                       width: '100%',
//                       height: '100%',
//                       position: 'absolute',
//                       borderRadius: 10,
//                       inset: 0,
//                     }}
//                   />

//                   <elements.CourseInWishlist
//                     course={course}
//                     size={20}
//                     style={{
//                       position: 'absolute',
//                       right: 0,
//                       top: 0,
//                       margin: 10,
//                     }}
//                     customFillColor={theme.colors.white}
//                     customStrokeColor={theme.colors.white}
//                   />
//                 </div>
//                 <div style={{ display: 'flex' }}>

//                   <div>
//                     {course.oldPrice && (
//                       <span
//                         style={{
//                           marginRight: 6,
//                           color: theme.colors.secondaryTextColor,
//                           textDecorationLine: 'line-through',
//                           ...theme.fonts.Lato_700Bold,
//                           fontSize: 18,
//                           lineHeight: 1.5,
//                           marginTop: 3,
//                         }}
//                       >
//                         ${course.oldPrice.toFixed(2)}
//                       </span>
//                     )}
//                     <text.T16 style={{ color: "#7065F0", ...theme.fonts.Lato_700Bold, }}>
//                       ${course.price.toFixed(2)}/Month
//                     </text.T16>
//                     <elements.CourseName
//                       course={course}
//                       numberOfLines={1}
//                       shortName={true}
//                     />
//                     <text.T16 style={{ color: "#000" }}>
//                       London University
//                     </text.T16>
//                     <elements.areaDescription
//                       course={course}
//                     // numberOfLines={1}
//                     // shortName={true}
//                     />

//                   </div>
//                 </div>
//               </SwiperSlide>
//             );
//           })}
//         </Swiper>
//       </div>
//     );
//   };
//   const renderReview = (): JSX.Element => {
//     return (
//       <div style={{ marginBottom: 0, marginTop: 40 }}>
//         <components.BlockHeading
//           title='What people are saying'

//           viewAllOnClick={() => {
//             // navigate('/category-list', { state: { title: 'Nearest For You' } });
//           }}
//           containerStyle={{ marginBottom: 12, padding: '0 20px' }}

//         />
//         <Swiper
//           spaceBetween={16}
//           slidesPerView="auto"
//           // centeredSlides={true}
//           pagination={{ clickable: true }}
//         >

//           {reviewsData?.slice(0, 3).map((review: any, index, array) => {
//             const isLast = index === array.length - 1;
//             return (
//               <SwiperSlide
//                 key={review.id}
//                 style={{
//                   width: 350,
//                   cursor: 'pointer',
//                   userSelect: 'none',
//                   borderRadius: 10,
//                   display: 'flex',
//                   flexDirection: 'column',
//                   position: 'relative',
//                   backgroundColor: "#F9FAFC",
//                   padding: "20px 20px 0px 20px"

//                 }}
//                 onClick={() => {

//                   // navigate('/course-details', { state: { review } });
//                 }}
//               >
//                 <div
//                   style={{
//                     position: 'relative',
//                     width: '100%',
//                     height: 320,
//                     marginBottom: 10,
//                   }}
//                 >
//                   <img
//                     src={review.image}
//                     alt={review.name}
//                     style={{
//                       width: '100%',
//                       height: '100%',
//                       position: 'absolute',
//                       borderRadius: 3,
//                       inset: 0,
//                     }}
//                   />
//                 </div>
//                 <div style={{}}>
//                   <reviews.ReviewCard
//                     review={review}
//                     section='reviews'
//                   />
//                 </div>
//               </SwiperSlide>
//             );
//           })}
//         </Swiper>
//       </div>
//     );
//   };
//   const renderCounter = (): JSX.Element => {
//     return (
//       <div style={{ marginBottom: 20, marginTop: 20 }}>

//         <div style={{
//           ...utils.rowCenter(),
//           display: "flex",
//           flexDirection: "column",
//           justifyContent: "center",
//           textAlign: "center"
//         }}>

//           <h3 style={{
//             color: theme.colors.darkTextColor,
//             ...theme.fonts.Lato_700Bold,
//             ...theme.flex,
//             fontSize: 28,
//           }} >Trusted by Over</h3>

//           <h3
//             style={{
//               fontSize: 90,
//               fontWeight: 'bold',
//               // lineHeight: 1,
//               background: 'linear-gradient(0deg, #FFFFFF 0%, #000000 100%)',
//               WebkitBackgroundClip: 'text', // This makes the background gradient clip to the text
//               WebkitTextFillColor: 'transparent', // This makes the text color transparent so the gradient shows through
//             }}
//           >
//             10000+
//           </h3>
//           <h3 style={{
//             // lineHeight: 1,
//             color: theme.colors.darkTextColor,
//             ...theme.fonts.Lato_700Bold,
//             ...theme.flex,
//             fontSize: 28
//           }} >Customer</h3>

//         </div>

//       </div>
//     );
//   };
//   const renderBottomCard = (): JSX.Element => {
//     return (
//       <div style={{
//         backgroundColor: "#F9FAFC",
//         marginBottom: 30,

//       }}>
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "space-evenly",
//             alignItems: "center",
//             textAlign: "center",
//             flexWrap: "wrap", // Helps responsiveness
//           }}
//         >
//           <div
//             style={{
//               flex: 2,
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//               justifyContent: "center",
//               textAlign: "center",
//             }}
//           >
//             <h3
//               style={{
//                 lineHeight: 1.2,
//                 color: theme.colors.darkTextColor,
//                 ...theme.fonts.LeagueSpartan_500Medium,
//                 fontSize: viewport.width < 500 ? 24 : 28,
//                 transition: "all",
//                 marginBottom: 5,
//               }}
//             >
//               Like the app?
//             </h3>
//             <h3
//               style={{
//                 lineHeight: 1.2,
//                 color: theme.colors.darkTextColor,
//                 ...theme.fonts.LeagueSpartan_500Medium,
//                 fontSize: viewport.width < 500 ? 24 : 28,
//                 transition: "all",
//                 marginBottom: 5,
//               }}
//             >
//               Share the app
//             </h3>
//             <button
//               style={{
//                 lineHeight: 1.2,
//                 marginTop: 15,
//                 color: theme.colors.white,
//                 backgroundColor: "#7065F0",
//                 padding: "6px 12px 6px 12px",
//                 borderRadius: 4,
//                 ...theme.fonts.LeagueSpartan_500Medium,
//                 fontSize: viewport.width < 500 ? 14 : 18,
//                 transition: "all"
//               }}
//             >
//               Share Now
//             </button>
//           </div>
//           <div
//             style={{
//               width: viewport.width < 500 ? 240 : 360,
//               backgroundColor: "transparent",
//               height: '100%',
//               objectFit: 'contain',
//             }}

//           >
//             <img
//               src={require('../../assets/nestfin/bottomcardimg.png')}
//               alt='Share the app illustration'
//               style={{
//                 // width: "100%",
//                 // height: '100%',
//                 objectFit: 'contain',
//               }}
//             />
//           </div>

//         </div>
//       </div>
//     );
//   };

//   const renderPopular = (): JSX.Element => {
//     return (
//       <div
//         style={{ marginBottom: 0, marginTop: 40 }} >
//         <components.BlockHeading
//           title='Locality Expert view'
//           viewAllOnClick={() => {
//             navigate('/category-list', { state: { title: 'Locality Expert view' } });
//           }}
//           containerStyle={{ marginBottom: 12, padding: '0 20px' }}
//         />
//         <Swiper
//           spaceBetween={16}
//           slidesPerView={'auto'}
//           pagination={{ clickable: true }}
//         >
//           {properties?.properties.map((course: any, index, array) => {
//             const isLast = index === array.length - 1;
//             return (
//               <SwiperSlide
//                 key={course.id}
//                 style={{
//                   width: 230,
//                   cursor: 'pointer',
//                   userSelect: 'none',
//                   borderRadius: 10,
//                   display: 'flex',
//                   flexDirection: 'column',
//                   position: 'relative',
//                 }}
//                 onClick={() => {
//                   navigate('/course-details', { state: { course } });
//                 }}
//               >
//                 <div
//                   style={{
//                     position: 'relative',
//                     width: '100%',
//                     height: 170,
//                     marginBottom: 10,
//                   }}
//                 >
//                   <img
//                     src={course.preview_90x90}
//                     alt={course.name}
//                     style={{
//                       width: '100%',
//                       height: '100%',
//                       position: 'absolute',
//                       borderRadius: 10,
//                       inset: 0,
//                     }}
//                   />
//                   <elements.CourseRating
//                     course={course}
//                     containerStyle={{
//                       position: 'absolute',
//                       left: 2,
//                       bottom: 2,
//                     }}
//                   />
//                   <elements.CourseInWishlist
//                     course={course}
//                     size={20}
//                     style={{
//                       position: 'absolute',
//                       right: 0,
//                       top: 0,
//                       margin: 10,
//                     }}
//                     customFillColor={theme.colors.white}
//                     customStrokeColor={theme.colors.white}
//                   />
//                 </div>
//                 <div style={{ display: 'flex' }}>
//                   <div style={{ marginRight: 8 }}>
//                     <svg.PlaySvg />
//                   </div>
//                   <div>
//                     <elements.CourseName
//                       course={course}
//                       numberOfLines={1}
//                       shortName={true}
//                     />

//                     <text.T16 style={{ color: theme.colors.secondaryTextColor }}>
//                       London University
//                     </text.T16>
//                   </div>
//                 </div>
//               </SwiperSlide>
//             );
//           })}
//         </Swiper>
//       </div>
//     );
//   };
//   const renderHeader = (): JSX.Element => {
//     return (
//       <components.Header
//         goBack={false}
//         line={false}
//         leftlogo={true}
//         rightlogo={true}
//         // search={true}
//         filter={false}
//         // logo={true}
//         title={''}
//       />
//     );
//   };
//   const renderContent = (): JSX.Element => {
//     return (
//       <main>
//         {renderTopBlock()}
//         {/*  */}
//         {renderSearchBar()}
//         {/* {renderCategories()} */}


//         {renderNearest()}
//         {renderTopRatedCourses()}
//         {renderPopular()}
//         {renderCarousel()}
//         {renderReview()}
//         {renderCounter()}
//         {renderBottomCard()}
//         {/* 
//          */}
//       </main>
//     );
//   };

//   return (
//     <>
//       {renderHeader()}
//       {renderContent()}
//       {renderBottomTabBar()}
//     </>
//   );
// };


